import request from '@/utils/request'

// 根据ids查询企业 (map结构)
export function reqCompanyByIds(data) {
  return request({
    url: '/admin/company/ids',
    method: 'post',
    params: data
  })
}

// 企业账号列表ids (map结构)
export function reqCompanyAccountByIds(data) {
  return request({
    url: '/admin/companyAccount/ids',
    method: 'post',
    params: data
  })
}

// 审核数量
export function reqVerifyCount() {
  return request({
    url: '/admin/companyAccount/authCount',
    method: 'post'
  })
}

// 企业账号列表
export function reqCompanyAccountList(data) {
  return request({
    url: '/admin/companyAccount/list',
    method: 'post',
    params: data
  })
}
// 所有企业列表
export function reqAllCompanyList(data) {
  return request({
    url: '/admin/company/list',
    method: 'post',
    params: data
  })
}
// 企业列表-ids
export function reqCompanyList(data) {
  data.pageSize = 100
  return request({
    url: '/admin/companyAccount/findCompanyByIds',
    method: 'post',
    params: data
  })
}

// 企业账号添加
export function reqAddCompanyAccount(data) {
  return request({
    url: '/admin/companyAccount/save',
    method: 'post',
    data
  })
}

// 审核数量
export function reqCompanyCount() {
  return request({
    url: '/admin/company/authCount',
    method: 'post'
  })
}

// 企业添加
export function reqAddCompany(data) {
  return request({
    url: '/admin/company/save',
    method: 'post',
    data
  })
}

// 用企业名搜索企业
export function reqCompanyByName(data) {
  return request({
    url: '/admin/companyAccount/searchCompanyByName',
    method: 'post',
    params: data
  })
}

// 更新企业账号认证状态
export function reqUpdateAccountAuth(data) {
  return request({
    url: '/admin/companyAccount/updateAuth',
    method: 'post',
    params: data
  })
}

// 更新企业认证状态
export function reqUpdateCompanyAuth(data) {
  return request({
    url: '/admin/company/updateAuth',
    method: 'post',
    data
  })
}
// 更新企业账号
export function reqUpdateCompanyAccount(data) {
  return request({
    url: '/admin/companyAccount/update',
    method: 'post',
    params: data
  })
}

// 更新企业账号
export function reqUpdateCompany(data) {
  return request({
    url: '/admin/company/update',
    method: 'post',
    data
  })
}
// 删除企业账号
export function reqDeleteAccount(data) {
  return request({
    url: '/admin/companyAccount/delete',
    method: 'post',
    params: data
  })
}

// 删除企业
export function reqDeleteCompany(data) {
  return request({
    url: '/admin/company/delete',
    method: 'post',
    params: data
  })
}

// 根据账号名获取公司
export function reqCompanyByAccount(data) {
  return request({
    url: '/admin/job/searchCompanyAccountByUsername',
    method: 'post',
    params: data
  })
}

// 删除职位
export function reqDeleteJob(data) {
  return request({
    url: '/admin/job/delete',
    method: 'post',
    params: data
  })
}
// 职位列表
export function reqJobList(data) {
  return request({
    url: '/admin/job/list',
    method: 'post',
    params: data
  })
}

// 保存职位
export function reqAddJob(data) {
  return request({
    url: '/admin/job/save',
    method: 'post',
    data
  })
}

// 审核数量
export function reqJobCount() {
  return request({
    url: '/admin/job/statusCount',
    method: 'post'
  })
}

// 保存职位
export function reqUpdateJob(data) {
  return request({
    url: '/admin/job/update',
    method: 'post',
    data
  })
}
// 通过分类id 获取 招聘职位
export function reqJobTitleOpt(data) {
  return request({
    url: '/admin/job/searchJobTitleByJobCategoryId',
    method: 'post',
    params: data
  })
}

// 获取工作分类
export function reqJobTitleCategory() {
  return request({
    url: '/admin/JobTitle/jobCategoryList',
    method: 'post'
  })
}

// 获取薪资范围
export function reqSalaryRange() {
  return request({
    url: '/admin/common/salaryOptions',
    method: 'post'
  })
}

// 获取职位标签可选范围
export function reqJobLabels() {
  return request({
    url: '/admin/common/jobLabels',
    method: 'post'
  })
}

// 根据jobid获取招聘职位
export function reqJobTitle(data) {
  return request({
    url: '/admin/job/searchJobTitleByJobTitleId',
    method: 'post',
    params: data
  })
}

// 根据jobid获取发布账号
export function reqCompanyAccount(data) {
  return request({
    url: '/admin/job/searchCompanyAccountIdByIds',
    method: 'post',
    params: data
  })
}

// 热门切换
export function reqToggleJobHot(data) {
  return request({
    url: '/admin/job/isMemberIndexHot',
    method: 'post',
    params: data
  })
}

// 企业反馈列表
export function reqCompanyFeedbackList(data) {
  return request({
    url: '/admin/companyFeedback/list',
    method: 'post',
    params: data
  })
}

// 更新职位审核状态
export function reqUpdateJobStatus(data) {
  return request({
    url: '/admin/job/updateStatus',
    method: 'post',
    data
  })
}

// 归属公司可选范围
export function getAttributionCompany(data) {
  return request({
    url: '/admin/common/attributionCompany',
    method: 'post',
    data
  })
}